import { I18n } from "i18n-js";
import en from "./locales/en";
import es from "./locales/es";
import fr from "./locales/fr";
import it from "./locales/it";
import pt from "./locales/pt";
import de from "./locales/de";
import nl from "./locales/nl";
import pl from "./locales/pl";
import sv from "./locales/sv";
import da from "./locales/da";
import ja from "./locales/ja";
import ko from "./locales/ko";
import zh from "./locales/zh";
import zhTW from "./locales/zh-TW";
import ar from "./locales/ar";
import hi from "./locales/hi";
import el from "./locales/el";
import tr from "./locales/tr";
import cs from "./locales/cs";
import sw from "./locales/sw";

export const i18n = new I18n({
  en,
  es,
  fr,
  it,
  pt,
  de,
  nl,
  pl,
  sv,
  da,
  ja,
  ko,
  zh,
  "zh-TW": zhTW,
  ar,
  hi,
  el,
  tr,
  cs,
  sw,
});

i18n.enableFallback = true;
i18n.defaultLocale = "en";

// Detect browser locale
const detectLocale = (): string => {
  const browserLocale = navigator.language; // e.g. "en-US", "zh-TW", "pt-BR"
  if (browserLocale === "zh-TW" || browserLocale === "zh-HK") return "zh-TW";
  const short = browserLocale.split("-")[0].toLowerCase();
  const supported = [
    "en",
    "es",
    "fr",
    "it",
    "pt",
    "de",
    "nl",
    "pl",
    "sv",
    "da",
    "ja",
    "ko",
    "zh",
    "ar",
    "hi",
    "el",
    "tr",
    "cs",
    "sw",
  ];
  return supported.includes(short) ? short : "en";
};

i18n.locale = detectLocale();

export default i18n;
